export default __webpack_public_path__ + "static/media/youtube-button.157c85ec.png";